exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textarea-style {\n  border: 1px solid #ccc;\n  width: 100%;\n  height: 80px;\n  border-radius: 15px;\n  padding: 5px;\n}\n.required-text {\n  border: 1px solid #f00 !important;\n  margin: 0;\n}\n#nohoverlink:hover {\n  color: #fff;\n}\n#nohoverlink {\n  float: left;\n  margin-bottom: 8px;\n  width: 11rem;\n}\n", ""]);

// exports
